import React from 'react';
import { Close } from '@mui/icons-material';
import { Box, Fade, Modal, Stack, Typography } from '@mui/material';

// ICONS
import ContactIcon from '../icons/ContactIcon';
import TemplatesIcon from '../icons/TemplatesIcon';
import UserListIcon from '../icons/UserListIcon';

export default function CustomModal({
  width,
  height = 'auto',
  title,
  setOpen,
  handleClose,
  showClose = true,
  icon,
  keepMounted = false,
  type,
  ...props
}) {
  const { children, open } = props;

  const handleDefaultOpenClose = () => {
    setOpen(!open);
  };

  const iconChoices = {
    contact: <ContactIcon sx={{ width: '100%', height: '100%' }} />,
    list: <UserListIcon sx={{ width: '100%', height: '100%' }} />,
    templates: <TemplatesIcon sx={{ width: '100%', height: '100%' }} />,
    userlist: <UserListIcon sx={{ width: '100%', height: '100%' }} />,
  };

  return (
    <Modal
      {...props}
      aria-labelledby="transition-modal-title"
      onClose={handleClose ?? handleDefaultOpenClose}
      closeAfterTransition
      keepMounted={keepMounted}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: width,
            maxHeight: '90%',
            maxWidth: '96%',
            bgcolor: 'background.paper',
            borderRadius: 2.5,
            paddingX: { xs: 2, md: 5 },
            paddingY: { xs: 2, md: 3 },
            overflowY: 'auto',
            border: '2px solid',
            borderColor: type === 'error' ? 'error.main' : 'secondary.light',
            height: height,
            overflow: 'auto',
          }}
        >
          {icon && (
            <Box
              sx={{
                color: 'grey.200',
                position: 'absolute',
                top: 4,
                left: -8,
                width: 52,
                height: 52,
                zIndex: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              {iconChoices[icon]}
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              position: 'relative',
              zIndex: 1,
            }}
          >
            {title && (
              <Stack
                direction="row"
                sx={{
                  marginBottom: 2,
                }}
              >
                <Typography
                  id="transition-modal-title"
                  variant="h2"
                  color={type === 'error' ? 'error.main' : 'secondary.main'}
                >
                  {title}
                </Typography>
              </Stack>
            )}

            {showClose && (
              <Close
                onClick={handleClose ?? handleDefaultOpenClose}
                sx={{
                  cursor: 'pointer',
                  zIndex: 1000,
                  marginBottom: title ? 0 : 5,
                  position: 'sticky',
                  top: 0,
                  right: 0,
                }}
              />
            )}
          </Box>

          {children}
        </Box>
      </Fade>
    </Modal>
  );
}
